export enum DateFormats {
  StandardDateFormat = 'MM/DD/YYYY',
  FullEuDateWithMonthAbbreviation = 'MMM DD,YYYY, h:mm A',
  Year = 'YYYY',
  MonthYear = 'MM/YYYY',
  Day = 'DD',
}
